class Whatsapp {
	constructor(config) {
		this.config = Object.assign({
			scope: '.whatsapp-link',
			open: '.js-whatsapp-open',
			box: '.whatsapp-box'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.on('click', this.config.open, (e) => {
			$(this.config.box).fadeToggle('fast');
			$(e.currentTarget).toggleClass('icon-whatsapp').toggleClass('icon-times');
		});
	}
}

export default new Whatsapp;